import { addRest, getValue } from '../../utils/parser-utils';
import { Range } from 'immutable';
import { ObjectLine } from 'z3k-parser/parser/utils/object-line';
function calibrationTables2Str(obj_id, obj) {
    return new ObjectLine(obj.id, obj_id, [
        //low
        obj.table.map((x) => Math.round(x.voltage) & 0xffff),
        obj.table.map((x) => x.value),
        //high
        obj.table.map((x) => (Math.round(x.voltage) & 0xffff0000) >> 16),
        ...(obj.rest || []),
    ]);
}
function calibrationTablesFromStr(id, params) {
    const table = Range(0, Math.max(params[0].length, params[1].length, getValue(params, 2, []).length))
        .map((_, i) => ({
        voltage_low: params[0][i] ?? 0,
        value: params[1][i] ?? 0,
        voltage_high: getValue(params, 2, [])[i] ?? 0,
    }))
        .map((v) => ({
        value: v.value,
        voltage: v.voltage_low | (v.voltage_high << 16),
    }))
        .toArray();
    return {
        id: id,
        table,
        multiply_x: 10,
        ...addRest(params, 4),
    };
}
export const calibration_table_parser = {
    toStr: calibrationTables2Str,
    fromStr: calibrationTablesFromStr,
};
